import type { Template } from "@/types";

export const PO_01_H0_V1: Template[] = [
    {
        id: "po-01-h0v1-01",
        name: "PO 01 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_01.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 713, y: 86, width: 450, height: 723, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-02",
        name: "PO 02 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_02.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 669, y: 41, width: 540, height: 813, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-03",
        name: "PO 03 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 401, y: 86, width: 450, height: 723, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-04",
        name: "PO 04 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_04.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 43, y: 41, width: 540, height: 813, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-05",
        name: "PO 05 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_05.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 88, y: 86, width: 450, height: 723, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-06",
        name: "PO 06 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_06.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 626, y: 0, width: 625, height: 894, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-07",
        name: "PO 07 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_07.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 626, y: 0, width: 548, height: 894, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-08",
        name: "PO 08 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 625, height: 894, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-09",
        name: "PO 09 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_09.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 78, y: 0, width: 548, height: 894, rotation: 0, imageRotation: 0 }
        ],
    }
];